import Colors from "../../../../theme/colors";

const style = {
  container: {
    color: Colors.white,
  },
  tableHeadCell: {
    fontSize: "12px",
    border: "none",
    padding: "18px 8px 18px 0",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // backgroundColor: "#DDDDDD",
    whiteSpace: "nowrap",
    color: "#5E5E5E",
    fontWeight: "600",
  },
  tableBody: {
    backgroundColor: "#FFFFFF",
    border: "none",
    color: Colors.white,
  },
  emptyList: {
    display: "flex",
    justifyContent: "center",
    padding: "1rem",
    width: "100%",
  },
};

export default style;
